import React from "react";
import "../../styles/PaymentTabs.css";

const tabs = [

    "Overview",

    "Customer",

    "Provider",

    "Settlement",

    "Refund",

    "Activity",

];

const PaymentTabs = ({
    activeTab,
    setActiveTab,
}) => {

    return (

        <div className="payment-tabs">

            {tabs.map((tab) => (

                <button
                    key={tab}
                    className={
                        activeTab === tab
                            ? "active"
                            : ""
                    }
                    onClick={() =>
                        setActiveTab(tab)
                    }
                >
                    {tab}
                </button>

            ))}

        </div>

    );

};

export default PaymentTabs;